/**
 * Runtime-observed private marker from ymaps `actionend`.
 * Used to separate user behavior actions from programmatic smooth map moves.
 */
export function isUserDrivenAction(actionPayload: unknown): boolean {
  const isObject = actionPayload !== null && typeof actionPayload === 'object';

  return isObject && '_activeBehaviorPriority' in actionPayload;
}
